import type { ElementInsertionPresetDefinition } from './types';

export function createOptionalInsertionPresets(
    presets: readonly ElementInsertionPresetDefinition[]
): { readonly presets?: readonly ElementInsertionPresetDefinition[] } {
    return presets.length > 0 ? { presets } : {};
}
